import { isRoutinesCampaignGame } from '#src/lib/game-utils';

import { Checkout as Classic } from '../Classic';
import { getCartComponent as getQuizCartComponent } from '../QuizCart';
import { RoutinesCart } from '../RoutinesCart';
import { Simplified } from '../Simplified';

export const selectCartComponent = ({
  gameOrderItem,
  membershipOrderItem,
  theme,
  cartVariant,
}) => {
  const isWayBetter = theme === 'waybetter';

  if (isWayBetter) {
    if (membershipOrderItem) {
      return getQuizCartComponent(cartVariant);
    }

    if (gameOrderItem) {
      const { game, paymentPlan } = gameOrderItem;

      if (isRoutinesCampaignGame(game)) {
        return RoutinesCart;
      }

      if (paymentPlan === 'non_member_game_fee_no_bet') {
        return Simplified;
      }
    }
  }

  return Classic;
};
